// extracted by mini-css-extract-plugin
module.exports = {"loadingContainer":"PlaidLoader_loadingContainer__x_I4p","loadingImage":"PlaidLoader_loadingImage__rTFww"};